module.exports = __webpack_public_path__ + "static/img/FO.24d688e4.svg";